import { Document, Types } from 'mongoose';
import status from '../../Labour/constant/status.json'

export const AvailableStatusEnum = {
    AVAILABLE: status.availability_status.Available,
    UNAVAILABLE: status.availability_status.Unavailable,
    ONLEAVE: status.availability_status.OnLeave,
    HOLIDAY: status.availability_status.Holiday
} as const;

export type AvailableStatus = typeof AvailableStatusEnum[keyof typeof AvailableStatusEnum];

export interface IAvailability {
    userId: Types.ObjectId;
    startDate: Date;
    endDate: Date;
    status: AvailableStatus;
    // companyName?: string;
    // location?: string;
    isDeleted: boolean;
    deletedAt?: Date;
    createdBy: Types.ObjectId;
    updatedBy?: Types.ObjectId;
    updatedAt?: Date
    holidayNotes?: string
    jobId: Types.ObjectId
    holiday?: string
}

export type IAvailabilityDocument = Document & IAvailability;
